import React, { useState, useEffect } from "react";
import { fetchKonnektInvitee, KonnektUserInvite, DeleteKonnektInvitation } from "js/Api/index";
import { generateUUID } from "js/helpers/common_functions";
import ContentCopy from "@mui/icons-material/ContentCopy";
import TrashIcon from "@mui/icons-material/DeleteRounded";
import toast from "react-hot-toast";

const InviteKonnektUserList = ({ reload_invite, user, openInviteModel }) => {
    const [InviteeUsers, setInviteeUsers] = useState([]);

    useEffect(() => {
        GetInvitee()
    }, [reload_invite]);

    useEffect(() => {
        if (openInviteModel === true) {
            setshowInviteModel(true);
        }
    }, [openInviteModel]);

    const GetInvitee = async () => {
        const result = await fetchKonnektInvitee(user.id);
        if (result.success) {
            setInviteeUsers(result.data);
        } else {
            console.log("Failed to fetch linked devices:", result.error);
        }
    };

    const [showInviteModel, setshowInviteModel] = useState(false);
    const handleInviteModel = () => {
        setshowInviteModel(true);
    };

    const CloseInviteModel = () => {
        setSkype_id("");
        setcontactName("");
        setshortName("");

        setinviteURL(null)
        setshowInviteModel(false);
    };

    const [skype_id, setSkype_id] = useState('')
    const [shortName, setshortName] = useState('')
    const [contactName, setcontactName] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState(null)
    const [inviteURL, setinviteURL] = useState(null)

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError(null);

        const result = await KonnektUserInvite(user.konnektDeviceId, contactName, skype_id, shortName);
        if (result.success) {
            setinviteURL(result.data.url)
            GetInvitee();
        }
        else {
            setError(result.error);
        }

        setIsLoading(false);
    }

    const [deleteInvite, setdeleteInvite] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const handleDeleteInvitationClick = (device) => {
        setdeleteInvite(device);
        setShowDeleteModal(true);
    };

    const handleDeleteInvitationCancel = () => {
        setShowDeleteModal(false);
        setdeleteInvite(null);
    };

    const handleDeleteInvitation = async () => {
        if (deleteInvite) {

            const result = await DeleteKonnektInvitation(deleteInvite.id);
            if (result.success) {
                toast.success(result.message);
                GetInvitee();
            } else {
                console.log("Failed :", result.error);
                toast.error(result.error);
            }
            setShowDeleteModal(false);
            setdeleteInvite(null);
        }
    };

    return (
        <>
            <div>
                <button onClick={handleInviteModel} type="button" className="btn cur-p btn-outline-dark" style={{ marginBottom: "20px" }} > Invite Konnekt Contact </button>
            </div>
            <table className="table table-hover">
                <thead>
                    <tr>
                        <th>Short Name</th>
                        <th>Displayed Name</th>
                        <th>Skype Id</th>
                        <th>Invited On</th>
                        <th>Invitation Link</th>
                        <th>&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    {InviteeUsers.map((device) => (
                        <tr key={device.id}>
                            <td style={{ verticalAlign: "middle" }}>{device.shortName}</td>
                            <td style={{ verticalAlign: "middle" }}>{device.name}</td>
                            <td style={{ verticalAlign: "middle" }}>{device.skypeId}</td>
                            <td style={{ verticalAlign: "middle" }}>{new Date(device.createdAt).toLocaleDateString("en-GB")}</td>
                            <td style={{ verticalAlign: "middle" }}>{device?.inviteURL || ''}&nbsp;&nbsp;
                                <ContentCopy onClick={() => {toast.success('Copied'); navigator.clipboard.writeText(device?.inviteURL || '') }} sx={{ color: "black", marginRight: "10px", cursor: "pointer", }} /></td>
                            <td>
                                <TrashIcon className="iconButtonStyle" onClick={() => handleDeleteInvitationClick(device)} />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {showInviteModel && (
                <div className="modal" role="dialog">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content" style={{ width: "500px" }}>
                            <div className="modal-header">
                                <h1 className="modal-title" style={{ fontWeight: 700 }}>
                                    {inviteURL != null && inviteURL !== "" ?
                                        "Invite Link Created" :
                                        "Invite Konnekt Contact"
                                    }
                                </h1>
                                <button className="close-button" onClick={() => CloseInviteModel()} > &times; </button>
                            </div>
                            <div className="modal-body">
                                {inviteURL != null && inviteURL !== "" ?
                                    <div>
                                        <div class="form-group">
                                            <div class="form-group">
                                                <label class="col-form-label" >Now, share this link with the person you're inviting to
                                                    the contact list.</label>
                                            </div>
                                            <div class="form-group">
                                                <label class="col-form-label" >Link</label>
                                                <div class="row">
                                                    <div class="col-9">
                                                        <input type="text" class="form-control" readOnly value={inviteURL} />
                                                    </div>
                                                    <div class="col">
                                                        <ContentCopy onClick={() => {toast.success('Copied'); navigator.clipboard.writeText(inviteURL) }}
                                                            sx={{ color: "black", marginRight: "10px", cursor: "pointer", }} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <div>
                                        <form onSubmit={handleSubmit}>
                                            <div class="form-group">
                                                <label class="col-form-label" >Videophone Profile Name</label>
                                                <input type="text" class="form-control" readOnly value={user.konnektDeviceId} />
                                            </div>
                                            <div class="form-group">
                                                <label class="col-form-label" >Contact Skype Id</label>
                                                <div class="row">
                                                    <div class="col">
                                                        <input type="text" class="form-control" required value={skype_id} onChange={(e) => setSkype_id(e.target.value)} />
                                                    </div>
                                                    <div class="col">
                                                        <button onClick={(e) => { e.preventDefault(); setSkype_id(generateUUID()) }} type="button" className="btn cur-p btn-outline-dark"> Generate Random UID </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label class="col-form-label" >Contact Short Name</label>
                                                <input type="text" class="form-control" required value={shortName} onChange={(e) => { setshortName(e.target.value); setcontactName(e.target.value); }} />
                                            </div>
                                            <div class="form-group">
                                                <label class="col-form-label" >CareWindow App Display Name</label>
                                                <input type="text" class="form-control" required value={contactName} onChange={(e) => setcontactName(e.target.value)} />
                                            </div>
                                            <div class="form-group text-center">
                                                <label for="staticEmail" class="col-form-label">&nbsp;</label>
                                                <button type="submit" class="btn btn-dark " disabled={isLoading}>Generate Invite Link</button>
                                            </div>
                                        </form>
                                        {error && (
                                            <div className="error-message" style={{ fontWeight: '700px', color: 'red', textAlign: 'center' }}>
                                                {error}
                                            </div>
                                        )}
                                        {isLoading && <div>Loading...</div>}
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showDeleteModal && (
                <div className="modal fade show" style={{ display: "block" }} aria-modal="true" role="dialog" >
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h1 className="modal-title">Delete Device</h1>
                                <button type="button" className="close-button" onClick={handleDeleteInvitationCancel} aria-label="Close" >  <span aria-hidden="true">&times;</span> </button>
                            </div>
                            <div className="modal-body">
                                <p> Are you sure you want to unenroll{" "} <strong>{deleteInvite?.name}</strong>? </p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={handleDeleteInvitationCancel} > Cancel </button>
                                <button type="button" className="btn btn-danger" onClick={handleDeleteInvitation} > Delete </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default InviteKonnektUserList;